import { Injectable } from '@angular/core';
import { ToastOptions, ToastyService } from 'ng2-toasty';

@Injectable({
  providedIn: 'root'
})
export class NotifyToastService {
  [x: string]: any;

  constructor(
    private toastyService: ToastyService
  ) { }

  showError(message: string) {
    const toastOptions: ToastOptions = {
      title: 'เกิดข้อผิดพลาด',
      msg: message,
      showClose: true,
      timeout: 5000,
      theme: 'bootstrap',
    };
    this.toastyService.error(toastOptions);
  }

  showSuccess(message: string) {
    const toastOptions: ToastOptions = {
      title: 'เรียบร้อย',
      msg: message,
      showClose: true,
      timeout: 5000,
      theme: 'bootstrap',
    };
    this.toastyService.success(toastOptions);
  }

}
